import * as React from 'react';
import { cloneDeep } from 'lodash';

import { IDocument, IUserData } from '../../../../infrastructure/interfaces';
import SettingsNav from './SettingsNav';
import AdditionalInfoEditorForm from '../../../DocumentEditor/AdditionalInfoForm/AdditionalInfoEditorForm';

export interface IAdditionalInfoEditorProps {
  document: IDocument;
  userData: IUserData;
  updateDocument(document: IDocument, userID: string): void;
  updateModelDocument?(document: IDocument): void;
  cancelDocument?(): void;
}

export interface ICompanyInfoEditorState {
  document: IDocument;
}
export default class CompanyInfoEditor extends React.Component<IAdditionalInfoEditorProps, ICompanyInfoEditorState> {
  constructor(props: IAdditionalInfoEditorProps) {
    super(props);
    this.state = {
      document: cloneDeep(props.document),
    };
  }

  componentWillUnmount() {
    if (this.props.updateModelDocument) {
      this.props.updateModelDocument(this.state.document);
    }
  }

  componentWillReceiveProps(nextProps: IAdditionalInfoEditorProps) {
    if (nextProps.document !== this.props.document) {
      this.setState({ document: cloneDeep(nextProps.document) });
    }
  }

  onFieldChange = (field: string, value: string | boolean) => {
    this.setState({
      document: {
        ...this.state.document,
        additionalInfo: {
          ...this.state.document.additionalInfo,
          [field]: value,
        },
      },
    });
  }

  cancel = () => {
    this.setState({ document: cloneDeep(this.props.document) });
    if (this.props.cancelDocument) {
      this.props.cancelDocument();
    }
  }

  onSave = () => {
    this.props.updateDocument(this.state.document, this.props.userData.id);
  }

  textPrompt() {
    if (this.state.document.type === "Postcard"){
      return "Optional Message for Back of Postcard:"
    } if (this.state.document.type === "Poster") {
      return "Title for Poster:"
    } else {
      return "Optional Cover Subtitle:"
    }
  } 
  
  render() {
    return (
      <div className="cropsEditorContainer">
        <SettingsNav
          cancel={this.cancel}
          document={this.state.document}
          onSave={this.onSave}
        />
        <div className="">
          <div className="cropsContainerTitle">
            { this.textPrompt()} 
          </div>
        </div>
        <AdditionalInfoEditorForm
          onFieldChange={(field, value) => this.onFieldChange(value, field)}
          document={this.state.document}
        />
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/Settings/AdditinalInfoEditor.tsx